import { render, staticRenderFns } from "./AddOrEditPlan.vue?vue&type=template&id=122bd2b1&scoped=true"
import script from "./AddOrEditPlan.vue?vue&type=script&lang=ts"
export * from "./AddOrEditPlan.vue?vue&type=script&lang=ts"
import style0 from "./AddOrEditPlan.vue?vue&type=style&index=0&id=122bd2b1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122bd2b1",
  null
  
)

export default component.exports